export enum Orientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  ReversePortrait = 'reverseportrait',
  NA = ''
}
